import { IEntrie } from '../../../../../modules/API/Knisot/models/entrie';

export const filterEntries = (items: IEntrie[], input: string): IEntrie[] => {
    if (!input) return items;
    return items.filter(
        (item) =>
            item.EntryNum.toString().includes(input) ||
            item.GrowerName?.trim().includes(input) ||
            item.Reference.toString().includes(input),
    );
};
